/* All free solid fontawesome icons -> https://fontawesome.com/icons?d=gallery&s=regular&m=free */

import {
  faBell,
  faCircle,
  faFileAlt,
  faKeyboard,
  faNewspaper,
  faPaperPlane,
  faSave,
  faSnowflake,
} from '@fortawesome/free-regular-svg-icons';

export const fontAwesomeRegularIcons = {
  faBell,
  faCircle,
  faFileAlt,
  faKeyboard,
  faNewspaper,
  faPaperPlane,
  faSave,
  faSnowflake,
};
